export default __webpack_public_path__ + "static/media/apple-cut@3x.ec3a3142.png";